import React, { Component } from 'react';

import LoadingSpinner from '../common/LoadingSpinner.js';

//import Footer from './Footer';
import UserTable from './UserTable';
import UserEdit from './UserEdit';


class UserManangement extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users:[],
      usersOnDisplay: [],
      userSearchInput: "",
      showEditUserPage: false,
      userInfo: null,
      loading: true,
    }
  }

  componentDidMount = () => {
    Promise.all([this.getUsers()])
      .then(() => this.setState({loading: false}));
  }

  getUsers = () => {
    return fetch('/api/getUsers', {method: "GET", credentials: "same-origin"})
      .then(res => {
        if (!res.ok) 
          throw Error(res.statusText);
        else
          return res.json();
      })
      .then((data) => {
        data = data.sort((a, b) => a.uid.localeCompare(b.uid));
        this.setState({users: data, usersOnDisplay: data});
      })
      .catch((error) => console.log(error));
  }

  handleSearchInputChange = (e) => {
    let searchString = e.target.value;

    if (searchString.length === 0) {
      this.setState({usersOnDisplay: this.state.users});
    } else {
      this.search(searchString);
    }
  }

  search = (searchString) => {
    searchString = searchString.toLowerCase();
    let newUsersOnDisplay = this.state.users.filter((user) => {
      return (
        user.uid.toLowerCase().includes(searchString)
        || user.firstName.toLowerCase().includes(searchString)
      );
    });
    this.setState({usersOnDisplay:newUsersOnDisplay});
  }

  editUser = (userInfo) => {
    this.setState({userInfo: userInfo, showEditUserPage:true })
  }

  cancelEditUser = () => {
    this.getUsers();
    this.setState({userInfo:null, showEditUserPage:false })
  }

  completeVerification = () => {
    this.setState({showEditUserPage:false })
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    if (this.state.userInfo === null) {
      return (
        <UserTable
          searchFunction={this.handleSearchInputChange}
          data={this.state.usersOnDisplay}
          edit={this.editUser}
        />
      );
    }

    return (
      <UserEdit
        user={this.state.userInfo}
        cancelEditUser={this.cancelEditUser}
        completeVerification={this.completeVerification}
      />
    );
  }
}

export default UserManangement;


// WEBPACK FOOTER //
// ./src/Components/userManagement/UserManagement.js